var scope_0 = require('/Volumes/Data/Projects/Personal/averin.photo/gatsby-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1bd842c43edbfef1946460f21fdd28d3.js').default;export default
        Object.assign({}, scope_0 )
    